import {ValueObject} from '@s-ui/domain'

import {DomainSharedError} from '../../shared/Errors/DomainSharedError.js'

export class ErrorFactoryFetcherValueObject extends ValueObject {
  #code
  #message
  #statusCode

  constructor({code, message, statusCode}) {
    super()
    this.#code = code
    this.#message = message
    this.#statusCode = statusCode
  }

  static createFromPrimitives({code, message, statusCode}) {
    return new ErrorFactoryFetcherValueObject({code, message, statusCode})
  }

  get code() {
    return this.#code
  }

  get message() {
    return this.#message
  }

  get statusCode() {
    return this.#statusCode
  }

  getDomainError() {
    return DomainSharedError.createFromPrimitives({code: this.code, message: this.message})
  }

  getFactory() {
    return [this.statusCode, () => this.getDomainError()]
  }

  get value() {
    return {
      code: this.code,
      message: this.message,
      statusCode: this.statusCode
    }
  }
}
